import api from './api';

/**
 * authService — login / logout and local session storage.
 *
 * On a successful login the backend returns:
 *   { userFound: true, uid, uname, ufull_name, role, jwt }
 * We stash the JWT and identity (including role) in localStorage; the axios
 * interceptor then attaches the JWT to every subsequent request.
 */
const STORAGE_KEYS = ['jwt', 'uid', 'uname', 'ufull_name', 'role'];

const clearSession = () => STORAGE_KEYS.forEach((k) => localStorage.removeItem(k));

const authService = {
  login: async (username, password) => {
    const response = await api.post('/users/login', { uname: username, upasswd: password });
    const data = response.data || {};

    if (!data.userFound || !data.jwt) {
      return response;
    }

    localStorage.setItem('jwt', data.jwt);
    localStorage.setItem('uid', String(data.uid));
    localStorage.setItem('uname', data.uname);
    localStorage.setItem('ufull_name', data.ufull_name || '');
    localStorage.setItem('role', data.role || 'doctor');
    return response;
  },

  logout: async () => {
    try {
      await api.get('/users/logout');
    } catch (err) {
      /* logging out regardless */
    }
    clearSession();
  },

  isAuthenticated: () => !!localStorage.getItem('jwt'),
  getRole: () => localStorage.getItem('role') || '',
  getUname: () => localStorage.getItem('uname') || '',
  getFullName: () => localStorage.getItem('ufull_name') || '',
  clearSession,
};

export default authService;
